import { inject, Injectable } from '@angular/core';
import { Configuration, FrontendApi } from '@ory/client';
import { OryIamConfig } from '../model';

/**
 * Wrapper service for Ory Kratos FrontendApi.
 *
 * Provides configured instance of Ory Client SDK's FrontendApi with
 * application-specific endpoint and credentials settings.
 */
@Injectable({
  providedIn: 'root',
})
export class OryApiService {
  readonly #config = inject(OryIamConfig).base;

  readonly api = new FrontendApi(
    new Configuration({
    basePath: this.#config.iamApiEndpoint,
    baseOptions: this.#config.baseOptions,
    })
  );
}
